(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-gallery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const galleries = document.querySelectorAll('.article-gallery');
  
  galleries.forEach(gallery => {
    const images = gallery.querySelectorAll('.article-gallery__image');
    const lightbox = gallery.querySelector('.article-gallery__lightbox');
    const lightboxImage = gallery.querySelector('.article-gallery__lightbox-image');
    const lightboxClose = gallery.querySelector('.article-gallery__lightbox-close');

    images.forEach(image => {
      image.addEventListener('click', function() {
        const fullImageUrl = this.dataset.fullImage;
        lightboxImage.src = fullImageUrl;
        lightbox.style.display = 'flex';
      });
    });

    lightboxClose.addEventListener('click', function() {
      lightbox.style.display = 'none';
    });

    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox) {
        lightbox.style.display = 'none';
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-gallery-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var sliderContainers = document.querySelectorAll('.custom-gallery-slider');
  
  sliderContainers.forEach(function(container) {
    var slider = new Flickity(container.querySelector('.slider-container'), {
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true,
      adaptiveHeight: true
    });

    var navBullets = container.querySelectorAll('.nav-bullet');
    // Initial first slide as current
    navBullets[0].classList.add('current');

    navBullets.forEach(function(bullet) {
      bullet.addEventListener('click', function() {
        var slideIndex = this.getAttribute('data-slide-index');
        
        // Remove current class from all bullets
        navBullets.forEach(function(b) {
          b.classList.remove('current');
        });
        
        // Add current class to clicked bullet
        this.classList.add('current');
        
        slider.select(slideIndex);
      });
    });

    // Update current bullet on slide change
    slider.on('select', function() {
      var currentSlide = slider.selectedIndex;
      
      // Remove current class from all bullets
      navBullets.forEach(function(bullet) {
        bullet.classList.remove('current');
      });
      
      // Add current class to the active slide's bullet
      navBullets[currentSlide].classList.add('current');
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-slider"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var slider = new Flickity('.slider-container', {
    prevNextButtons: false,
    pageDots: false,
    wrapAround: true
  });

  var navBullets = document.querySelectorAll('.nav-bullet');
  navBullets.forEach(function(bullet) {
    bullet.addEventListener('click', function() {
      var slideIndex = this.getAttribute('data-slide-index');
      slider.select(slideIndex);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
